import { schema } from 'normalizr'
import store from '../../store'
export default new schema.Entity(
    'positions',
    {},
    {
        idAttribute: 'deviceId',
        processStrategy: position => ({
            // Meta
            _type: 'position',
            //Relations
            _device: () => store.getters.devices[position.deviceId],
            //Fields
            ...position,
        }),
    }
)
